import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import BrandMark from "./BrandMark";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/topics", label: "话题榜", end: false },
  { to: "/discussion", label: "讨论区", end: false },
  { to: "/about", label: "关于我们", end: false },
  { to: "/faq", label: "常见问题", end: false },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/92 border-b border-background-200/80 backdrop-blur-md"
          : "bg-background-50/70 border-b border-transparent backdrop-blur-sm"
      }`}
    >
      <nav
        className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4"
        aria-label="主导航"
      >
        <BrandMark />

        <ul className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors duration-200 ${
                    isActive
                      ? "bg-primary-100 text-primary-800 font-medium"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-background-200/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <span className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse" />
            热榜已更新
          </span>
          <Link
            to="/discussion"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
          >
            <i className="ri-chat-smile-2-line text-base w-4 h-4 flex items-center justify-center" />
            我也来说两句
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-800 hover:bg-background-200/60 transition-colors"
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200/80 bg-background-50">
          <ul className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `block px-4 py-3 rounded-xl text-sm transition-colors ${
                      isActive
                        ? "bg-primary-100 text-primary-800 font-medium"
                        : "text-foreground-700 hover:bg-background-200/60"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li className="pt-1">
              <Link
                to="/discussion"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-1.5 px-4 py-3 rounded-xl bg-primary-500 text-background-50 text-sm"
              >
                <i className="ri-chat-smile-2-line" />
                我也来说两句
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}